import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	stepFourWrapper: {
		display       : "flex",
		flexDirection : "column",
		gap           : "1rem"
	}
} );